import { Box } from '@chakra-ui/react';

import VarianceWrapper from '../../variance/VarianceWrapper';

import { BaseInstrumentProperties } from './proptypes';

export const VarianceInstrument = ({ widget, output }: BaseInstrumentProperties) => {
  const buildVarianceOutput = (outputData: any) => ({
    ...outputData,
    data: output?.data?.map((item: any, index: number) => {
      const widgetIndicator = outputData?.instrument_indicators?.[index];
      const existingIndicator = item?.indicator;

      // Prefer the enriched API indicator (it includes indicator_name),
      // but keep widget-level fields like block_id / formatting.
      const mergedIndicator = {
        ...(existingIndicator ?? undefined),
        ...(widgetIndicator ?? undefined),
      };

      const indicatorName =
        mergedIndicator?.indicator_name ??
        mergedIndicator?.name ??
        existingIndicator?.indicator_name ??
        existingIndicator?.name ??
        widgetIndicator?.indicator_name ??
        widgetIndicator?.name;

      if (indicatorName != null) {
        mergedIndicator.indicator_name = indicatorName;
        mergedIndicator.name = mergedIndicator.name ?? indicatorName;
      }

      return { ...item, indicator: mergedIndicator };
    }),
  });

  return (
    <Box height='100%' width='100%'>
      <VarianceWrapper
        output={buildVarianceOutput(widget)}
        columnSettings={widget?.formatting?.columns_settings}
        columnPositions={widget?.formatting?.columns_position}
      />
    </Box>
  );
};

export default VarianceInstrument;
